import { graphql, useStaticQuery } from "gatsby"

const useMainMenu = () => {
  const { menu } = useStaticQuery(
    graphql`
      query {
        menu: shopifyMenu(handle: { eq: "main-menu" }) {
          items {
            title
            type
            items {
              type
              title
              url
            }
          }
        }
      }
    `
  )
  return menu
}

export default useMainMenu
